import { render, staticRenderFns } from "./ActivityQna.vue?vue&type=template&id=38034ce2"
import script from "./ActivityQna.vue?vue&type=script&lang=js"
export * from "./ActivityQna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports